<template>
  <div class="transactions">
    <div class="filter-bar">
      <select v-model="filters.type" class="filter-select">
        <option value="">全部类型</option>
        <option value="1">充值</option>
        <option value="2">消费</option>
        <option value="3">提现</option>
        <option value="4">退款</option>
        <option value="5">冻结</option>
        <option value="6">解冻</option>
        <option value="7">服务费</option>
      </select>
      <select v-model="filters.status" class="filter-select">
        <option value="">全部状态</option>
        <option value="1">成功</option>
        <option value="0">待处理</option>
        <option value="-1">失败</option>
      </select>
      <select v-model="filters.roleCode" class="filter-select">
        <option value="">全部角色</option>
        <option value="user">用户</option>
        <option value="runner">跑手</option>
        <option value="shop">店家</option>
        <option value="shop_referrer">店家推广人</option>
        <option value="runner_referrer">跑手推广人</option>
        <option value="community_agent">社区代理</option>
        <option value="platform">平台</option>
      </select>
      <input v-model="filters.operatorName" class="filter-input" placeholder="操作员姓名" @keyup.enter="loadTransactions" />
      <input v-model="filters.keyword" class="filter-input" placeholder="用户ID / 流水号" @keyup.enter="loadTransactions" />
      <button class="btn btn-primary" @click="loadTransactions">查询</button>
      <button class="btn btn-default" @click="resetFilters">重置</button>
    </div>

    <table class="data-table">
      <thead>
        <tr>
          <th>ID</th>
          <th>用户ID</th>
          <th>用户</th>
          <th>类型</th>
          <th>金额</th>
          <th>余额变化</th>
          <th>说明</th>
          <th>操作员</th>
          <th>状态</th>
          <th>流水号</th>
          <th>时间</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in list" :key="item.id">
          <td>{{ item.id }}</td>
          <td>{{ item.user_id }}</td>
          <td>{{ item.user ? (item.user.real_name || item.user.name) : '-' }}</td>
          <td>{{ typeText(item.transaction_type) }}</td>
          <td :class="['amount', item.transaction_type === 1 || item.transaction_type === 4 ? 'plus' : 'minus']">
            {{ item.transaction_type === 1 || item.transaction_type === 4 ? '+' : '-' }}{{ (Math.abs(item.amount) / 100).toFixed(2) }}
          </td>
          <td>{{ (item.balance_before / 100).toFixed(2) }} → {{ (item.balance_after / 100).toFixed(2) }}</td>
          <td>{{ item.description || '-' }}</td>
          <td>
            <span v-if="item.operator_name">{{ item.operator_name }}</span>
            <span v-else-if="item.operator_id">ID:{{ item.operator_id }}</span>
            <span v-else class="muted">系统</span>
          </td>
          <td>
            <span :class="['status-tag', statusText(item.status).cls]">{{ statusText(item.status).text }}</span>
          </td>
          <td>{{ item.transaction_no || '-' }}</td>
          <td>{{ item.created_at }}</td>
        </tr>
        <tr v-if="list.length === 0">
          <td colspan="11" class="empty">暂无数据</td>
        </tr>
      </tbody>
    </table>

    <div class="pagination" v-if="total > 0">
      <button class="page-btn" :disabled="currentPage <= 1" @click="changePage(currentPage - 1)">上一页</button>
      <span class="page-info">第 {{ currentPage }} / {{ totalPages }} 页（共 {{ total }} 条）</span>
      <button class="page-btn" :disabled="currentPage >= totalPages" @click="changePage(currentPage + 1)">下一页</button>
    </div>
  </div>
</template>

<script>
import { getTransactions } from '@/api/finance'

export default {
  name: 'Transactions',
  data() {
    return {
      list: [],
      total: 0,
      currentPage: 1,
      // 从跑手详情“查看全部”带入的 runner_id，按跑手独立钱包精确过滤（与详情页口径一致）
      runnerId: '',
      filters: {
        type: '',
        status: '',
        roleCode: '',
        operatorName: '',
        keyword: ''
      }
    }
  },
  mounted() {
    // 支持从 URL 带入初始筛选（如 ?user_id=123&operator_name=xxx）
    const q = this.$route.query || {}
    if (q.user_id) {
      this.filters.keyword = String(q.user_id)
    }
    if (q.operator_name) {
      this.filters.operatorName = String(q.operator_name)
    }
    // 从跑手详情“查看全部”带入：按 runner_id 精确过滤跑手钱包流水
    if (q.runner_id) {
      this.runnerId = String(q.runner_id)
    }
    // 角色筛选：优先用 URL 的 role_code；从跑手详情进入时下拉默认“跑手”，与精确结果一致
    if (q.role_code) {
      this.filters.roleCode = String(q.role_code)
    } else if (q.runner_id) {
      this.filters.roleCode = 'runner'
    }
    this.loadTransactions()
  },
  computed: {
    // 每页 20 条（与后端 paginate(20) 保持一致）
    totalPages() {
      return Math.ceil(this.total / 20) || 1
    }
  },
  methods: {
    async loadTransactions(extra = {}) {
      try {
        const params = {
          page: this.currentPage,
          type: this.filters.type || undefined,
          status: this.filters.status !== '' ? this.filters.status : undefined,
          operator_name: this.filters.operatorName || undefined,
          keyword: this.filters.keyword || undefined,
          role_code: this.filters.roleCode || undefined,
          runner_id: this.runnerId || undefined,
          ...extra
        }
        const res = await getTransactions(params)
        // 响应结构：{ data: { current_page, data: [items], total, ... } }
        // 请求拦截器已返回 response.data，故 res.data 即为分页对象（paginator）
        const paginator = res.data || {}
        this.list = paginator.data || []
        this.total = paginator.total || this.list.length
      } catch (e) {
        this.$message && this.$message.error('加载失败')
      }
    },
    resetFilters() {
      this.filters = { type: '', status: '', roleCode: '', operatorName: '', keyword: '' }
      this.currentPage = 1
      this.loadTransactions()
    },
    changePage(page) {
      this.currentPage = page
      this.loadTransactions()
    },
    typeText(type) {
      const map = { 1: '充值', 2: '消费', 3: '提现', 4: '退款', 5: '冻结', 6: '解冻', 7: '服务费' }
      return map[type] || '未知'
    },
    statusText(status) {
      if (status === 1) return { text: '成功', cls: 'success' }
      if (status === 0) return { text: '待处理', cls: 'pending' }
      if (status === -1) return { text: '失败', cls: 'failed' }
      return { text: '未知', cls: '' }
    }
  }
}
</script>

<style scoped>
.filter-bar {
  display: flex;
  gap: 10px;
  margin-bottom: 16px;
  flex-wrap: wrap;
  align-items: center;
}
.filter-input,
.filter-select {
  padding: 8px 12px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  font-size: 14px;
}
.data-table {
  width: 100%;
  border-collapse: collapse;
  background: #fff;
  border-radius: 6px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}
.data-table th,
.data-table td {
  padding: 11px 12px;
  text-align: left;
  border-bottom: 1px solid #f0f0f0;
  font-size: 13px;
  color: #333;
  white-space: nowrap;
}
.data-table th {
  background: #fafafa;
  font-weight: 600;
}
.data-table tr:hover td {
  background: #f9faff;
}
.empty {
  text-align: center;
  color: #999;
  padding: 30px 0;
}
.btn {
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}
.btn-primary {
  background: #667eea;
  color: #fff;
}
.btn-default {
  background: #eee;
  color: #333;
}
.amount.plus {
  color: #2ecc71;
  font-weight: 600;
}
.amount.minus {
  color: #e74c3c;
  font-weight: 600;
}
.muted {
  color: #aaa;
}
.status-tag {
  padding: 3px 10px;
  border-radius: 12px;
  font-size: 12px;
}
.status-tag.success {
  background: #e8f8f0;
  color: #2ecc71;
}
.status-tag.pending {
  background: #eef4ff;
  color: #667eea;
}
.status-tag.failed {
  background: #fdecea;
  color: #e74c3c;
}
.pagination {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 14px;
  margin-top: 16px;
}
.page-btn {
  padding: 6px 14px;
  border: 1px solid #dcdfe6;
  background: #fff;
  border-radius: 4px;
  cursor: pointer;
}
.page-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.page-info {
  font-size: 14px;
  color: #666;
}
</style>
